import "./JonesboroServiceArea.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import FlagshipWelcome from "./sections/FlagshipWelcome";
import CoreServices from "./sections/CoreServices";
import PlumbingProblems from "./sections/PlumbingProblems";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function JonesboroServiceAreaPage() {
  return <div>
      <Header />
      <HeroBanner />
      <FlagshipWelcome />
      <CoreServices />
      <PlumbingProblems />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}